import { getSupabaseClient } from "./supabaseClient";

export async function enrollMFA() {
    const supabase = getSupabaseClient();
    const { data, error } = await supabase.auth.mfa.enroll({
        factorType: "totp",
    });
    if (error) {
        throw error;
    }
    return data;
}

export async function verifyMFA({ factorId, challengeId, code }) {
    const supabase = getSupabaseClient();
    const payload = {
        factorId,
        code,
    };
    if (challengeId) {
        payload.challengeId = challengeId;
    }

    const { data, error } = await supabase.auth.mfa.verify(payload);
    if (error) {
        throw error;
    }
    return data;
}

export async function unenrollMFA({ factorId }) {
    const supabase = getSupabaseClient();
    const { data, error } = await supabase.auth.mfa.unenroll({ factorId });
    if (error) {
        throw error;
    }
    return data;
}

export async function challengeMFA({ factorId }) {
    const supabase = getSupabaseClient();
    const { data, error } = await supabase.auth.mfa.challenge({ factorId });
    if (error) {
        throw error;
    }
    return data;
}

export async function listMFAFactors() {
    const supabase = getSupabaseClient();
    const { data, error } = await supabase.auth.mfa.listFactors();
    if (error) {
        throw error;
    }
    return data;
}
